import React, { useEffect, useState } from "react";
import PillContainer from "../../components/product-page-pills/PillContainer";
import Recentcs from "../../components/suggestions/Suggestion";
import SizeSelector from "../../components/size-selector/SizeSelector";
import { Button } from "react-bootstrap";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
  useParams,
  Link,
} from "react-router-dom";
import axios from "axios";

import shoe from "../../temporary-data/shoeee.jpg";

import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Mousewheel,
} from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

import "./Product.scss";
// import "./ProductMobile.scss";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";
import Suggestion from "../../components/suggestions/Suggestion";
import BuyOrderButton from "../../components/buy-order-button/BuyOrderButton";
import SizeSelectProd from "../../components/size-selector-product/SizeSelectProd";
import SizeBuyProd from "../../components/size-buy-offer-product/SizeBuyProd";
import { connect } from "react-redux";
import * as Actions from "../../Redux/Actions";
import sizeBox from "../../components/size-box-mobile/SizeBox";
import FilterMobile from "../../components/filter-mobile-view/FilterMobile";
import SizeBox from "../../components/size-box-mobile/SizeBox";
import SizeSelectorMobile from "../../components/size-selector-mobile/SizeSelectorMobile";
import Footer from "../../components/footer/Footer";
import Links from "../../components/links/Links";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Mousewheel]);
// SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
const Product = (props) => {
  var id = useParams().id;
  var mainURL = "https://appick.io/u/thriller/imgs/";

  var usr = JSON.parse(localStorage.getItem("user"));
  var sz = "4";
  if (usr !== null && usr !== undefined) sz = usr.defaultSize;
  const [product, setProduct] = useState({});
  const [images, setImages] = useState([]);
  const [defaultSize, setDefaultSize] = useState(sz);
  const [lowestAsk, setLowestAsk] = useState(0);
  const [showSizeChart, setSizeChart] = useState(false);
  const [favSize, setFavSize] = useState(sz);
  function Load() {
    console.log("Loading....");
    //props.setID(id);
    // if (product.sku_number === undefined) {
    //   var url = `https://api.thrillerme.com/shoes/${id}`;
    //   var encodedURL = encodeURI(url);
    //   axios.get(encodedURL).then((res) => {
    //     setProduct(res.data);
    //   });
    // }

    var user = localStorage.getItem("user");
    if (user !== null) {
      var userID = JSON.parse(user).user_id;
      var urlUser = `https://api.thrillerme.com/registrations/${userID}`;
      var encodedURLU = encodeURI(urlUser);
      axios.get(encodedURLU).then((res) => {
        if (res.data.defaultSize !== null) {
          setDefaultSize(res.data.defaultSize);
        }
        //console.log("User Default size: ", defaultSize);
      });
    }

    GetLowsetAsk(defaultSize);
  }

  function LoadDetails() {
    var url = `https://api.thrillerme.com/shoes/${id}`;
    var encodedURL = encodeURI(url);
    axios.get(encodedURL).then((res) => {
      var date = res.data.release_date;
      var data = res.data;
      if (date !== null && date !== undefined) {
        date = date.split("T")[0];
        data.release_date = date;
      }

      setProduct(data);
      GetLowsetAsk(defaultSize);
      localStorage.setItem("favSize", defaultSize);
    });

    axios
      .get(`https://api.thrillerme.com/shoesImages/${id}`)
      .then((res) => {
        console.log("img", res.data);
        setImages(res.data);
      })
      .catch((err) => {
        console.error("imgs error", err);
      });
  }

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    Load();
  }, []);

  useEffect(() => {
    LoadDetails();
  }, [id]);

  function updateSizeValue(val) {
    setDefaultSize(val);
    GetLowsetAsk(val);
    // setFavSize(val);
  }

  function GetLowsetAsk(sizz) {
    var urlL = `https://api.thrillerme.com/listing/lowest/${id}/${sizz}`;
    console.log(urlL);
    var encodedURLL = encodeURI(urlL);
    axios.get(encodedURLL).then((res) => {
      if (res.data.lowest !== null) {
        setLowestAsk(res.data.lowest);
      } else {
        setLowestAsk(0);
      }
    });
  }

  //console.log("joota", product);
  window.scrollTo(0, 0);
  return (
    <div className="product-page-container">
      <div class="prod-top-contain">
        <div className="conText blink">
          <span>CONDITION:</span>
          <span style={{ color: "#ec1d25" }}> NEW</span>
        </div>
        <PillContainer shoe_id={id} favSize={favSize} />
      </div>
      <div className="prod-container">
        <div className="prod-info-container">
          <span style={{ color: "gray" }}>
            <span style={{ fontWeight: "500", margin: "0px", color: "black" }}>
              SKU:
            </span>
            &nbsp;{product.sku_number}
          </span>
          <span style={{ color: "gray" }}>
            <span style={{ fontWeight: "500", margin: "0px", color: "black" }}>
              COLORWAY:
            </span>
            &nbsp;{product.colorway}
          </span>
          {product.release_date !== null && (
            <span style={{ color: "gray" }}>
              <span
                style={{ fontWeight: "500", margin: "0px", color: "black" }}
              >
                RELEASE DATE:
              </span>
              &nbsp;{product.release_date}
            </span>
          )}
        </div>
        <div className="prod-img-container">
          <div class="d-flex flex-column align-self-center prod-img-text-container">
            <span>{product.name}</span>
          </div>
          <div
            className="shoeImg"
            style={{
              height: "100%",
              width: "100%",
              // backgroundImage: `url(${shoe})`,
            }}
          >
            <Swiper
              spaceBetween={50}
              slidesPerView={1}
              scrollbar={{ draggable: true }}
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
              // mousewheel={true}
            >
              <SwiperSlide>
                <img src={product.cover_image} alt={product.sku_number}></img>
              </SwiperSlide>
              {images.map(function (name, index) {
                return (
                  <SwiperSlide key={index}>
                    <img src={name.imgURL} alt={name.imgURL}></img>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
        <div className="prod-size-container">
          {/* <span>AED 1400 |</span>
          <SizeSelector /> */}
          <SizeBuyProd
            price={lowestAsk}
            size={defaultSize}
            id={id}
            setFavSize={setFavSize}
            parentCallBack={updateSizeValue}
            lowestAsk={lowestAsk}
          />
        </div>
      </div>
      <div className="mob-prod-container">
        <div class="mob-prod-top-contain">
          <div className="conText blink">
            <span>CONDITION:</span>
            <span style={{ color: "#ec1d25" }}> NEW</span>
          </div>
          <div>
            <Button
              style={{
                height: "35px",
                width: "85px",
                background: "#ec1d25",
                borderColor: "#ec1d25",
                padding: "0px",
                marginLeft: "5px",
                marginTop: "2px",
                marginBottom: "5px",
              }}
              onClick={() => setSizeChart(true)}
            >
              <span className="p-0 m-0 selltxt">Buy Now</span>
            </Button>
          </div>
        </div>
        {/* <div
          className="mob-prod-img-container"
          style={{
            backgroundImage: `url(${product.cover_image})`,
          }}
        ></div> */}

        <div className="prod-img-container">
          {/* <div class="d-flex flex-column align-self-center prod-img-text-container">
            <span>{product.name}</span>
          </div> */}
          <div
            className="shoeImg"
            style={{
              height: "100%",
              width: "100%",
              // backgroundImage: `url(${shoe})`,
            }}
          >
            <Swiper
              spaceBetween={50}
              slidesPerView={1}
              scrollbar={{ draggable: true }}
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
              mousewheel={true}
            >
              <SwiperSlide>
                <img src={product.cover_image} alt={product.sku_number}></img>
              </SwiperSlide>
              {images.map(function (name, index) {
                return (
                  <SwiperSlide key={index}>
                    <img src={name.imgURL} alt={name.imgURL}></img>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>

        <div class="d-flex flex-column align-items-center">
          <div>
            <span>{product.name}</span>
          </div>
          <div>
            <span>{product.colorway}</span>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <PillContainer shoe_id={id} />
        </div>
        {showSizeChart ? (
          <div class="d-flex justify-content-center align-item-center">
            <SizeSelectorMobile
              showSizeChart={showSizeChart}
              setSizeChart={setSizeChart}
              lowestAsk={lowestAsk}
              id={id}
              shoe={product}
            />
          </div>
        ) : null}

        <div className="prod-info-container">
          <div className="prod-price-container">
            <span>AED {lowestAsk}</span>
          </div>
          <div style={{ textAlign: "center" }}>
            <span>
              {product.sku_number}&nbsp;|&nbsp;{product.colorway}
            </span>
          </div>

          {product.release_date !== null &&
            product.release_date !== undefined && (
              <span>RELEASE DATE: {product.release_date}</span>
            )}
        </div>
      </div>

      <div className="prod-text">{product.summary}</div>
      <div className="prod-page-suggest">
        <Suggestion
          collection_id={id}
          shoe_id={product.shoe_id}
          name="You May Also Like"
        />
      </div>
      <Links />
      <Footer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setID: (data) => {
      dispatch({ type: Actions.SET_SHOE_ID, payload: data });
    },
  };
};

export default connect(null, mapDispatchToProps)(Product);
